const template = `
</div>
<div class="bottom-conditions">
	<form>
		<div class="conditions-container ranking">
			<h2 class="ranking-results-heading"></h2>
			<div class="conditions-inner">

				<p class="no-result ranking-results-no-result"></p>

				<div class="table-container fiveplus-results">
					<h3 class="ranking-fiveplus-results-heading"></h3>
					<table>
						<thead>
							<tr>
								<th class="ranking-fiveplus-place"></th>
								<th class="ranking-fiveplus-horse-nr"></th>
							</tr>
						</thead>
						<tbody>
							<tr data-sticky-template="bottom-conditions-ranking-fiveplus-results-row">
								<td class="place"></td>
								<td class="hidden">
									<label class="checkbox">
										<input type="hidden" value="0" name="">
										<input type="checkbox" value="1" name="">
										<span></span>
									</label>
								</td>
								<td class="horse"></td>
							</tr>
						</tbody>
					</table>
					<div class="toggle-all-wrapper">
						<span class="sprite view-result"></span>
						<a class="toggle-all"></a>
					</div>
				</div>

				<div class="table-container winners-and-values">
					<h3 class="ranking-results-winners-and-values"></h3>
					<table>
						<thead>
							<tr>
								<th class="ranking-results-leg"></th>
								<th class="ranking-results-status"></th>
								<th class="ranking-results-show"></th>
								<th class="ranking-results-winner"></th>
								<th class="ranking-results-value"></th>
								<th class="ranking-results-correct"></th>
							</tr>
						</thead>
						<tbody>
							<tr data-sticky-template="bottom-conditions-ranking-winners-and-values-row">
								<td class="leg"></td>
								<td class="status"></td>
								<td class="show">
									<label class="checkbox">
										<input type="hidden" value="0" name="">
										<input type="checkbox" value="1" name="">
										<span></span>
									</label>
								</td>
								<td class="winner"></td>
								<td class="value money"></td>
								<td style="" class="correct"></td>
							</tr>
						</tbody>
					</table>
					<div class="toggle-all-wrapper">
						<span class="sprite view-result"></span>
						<a class="toggle-all"></a>
					</div>
				</div>

				<div class="table-container dividends">
					<h3 class="ranking-dividends-dividends"></h3>
					<table>
						<thead>
							<tr>
								<th class="ranking-dividends-number-of-corrects"></th>
								<th class="ranking-dividends-dividend"></th>
							</tr>
						</thead>
						<tbody>
							<tr data-sticky-template="bottom-conditions-ranking-dividend-row">
								<td class="number-of-corrects"></td>
								<td class="dividend money"></td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="table-container dividends-per-horse">
					<h3 class="ranking-dividends-per-horse-header"></h3>
					<table>
						<thead>
							<tr>
								<th class="ranking-dividends-per-horse-start-number"></th>
								<th class="ranking-dividends-per-horse-dividend"></th>
							</tr>
						</thead>
						<tbody>
							<tr data-sticky-template="bottom-conditions-ranking-dividend-per-horse-row">
								<td class="start-number"></td>
								<td class="dividend money"></td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="table-container preliminary-dividend-per-horse">
					<h3 class="ranking-preliminary-dividend-per-horse-header"></h3>
					<table>
						<thead>
							<tr>
								<th class="ranking-dividends-per-horse-start-number"></th>
								<th class="ranking-dividends-per-horse-dividend"></th>
							</tr>
						</thead>
						<tbody>
							<tr data-sticky-template="bottom-conditions-ranking-preliminary-dividend-per-horse-row">
								<td class="start-number"></td>
								<td class="dividend money"></td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="table-container odds">
					<h3 class="ranking-odds-heading"></h3>
					<table>
						<thead>
						</thead>
						<tbody>
							<td class="show" data-sticky-template="bottom-conditions-ranking-odds-cell-show">
								<label class="checkbox">
									<input type="hidden" value="0" name="">
									<input type="checkbox" value="1" name="">
									<span></span>
								</label>
							</td>
						</tbody>
					</table>
					<div class="toggle-all-wrapper">
						<span class="sprite view-result"></span>
						<a class="toggle-all"></a>
					</div>
				</div>

				<div class="table-container my-dividends">
					<h3 class="ranking-my-dividends"></h3>
					<div class="rikstoto-dividend-notice"></div>
					<table>
						<thead>
							<tr>
								<th class="ranking-my-dividends-rows"></th>
								<th class="ranking-my-dividends-dividend"></th>
							</tr>
						</thead>
						<tbody>
							<tr data-sticky-template="bottom-conditions-ranking-my-dividends-row">
								<td class="number-of-rows"></td>
								<td class="dividend money"></td>
							</tr>
							<tr class="total-row" data-sticky-template="bottom-conditions-ranking-my-dividends-sum">
								<td class="total"></td>
								<td class="dividend money"></td>
							</tr>
							<tr class="separator" data-sticky-template="bottom-conditions-ranking-my-dividends-separator">
								<td colspan="2"></td>
							</tr>
							<tr class="extra-row" data-sticky-template="bottom-conditions-ranking-my-dividends-extra">
								<td class="value"></td>
								<td class="dividend money"></td>
							</tr>
						</tbody>
					</table>
				</div>

				<!-- div class="table-container legend">
					<h3 class="ranking-odds-head" id="legend-label">rubrik</h3>
					<table>
						<thead>
							<tr>
								<th>Färg</th>
								<th>Betydelse</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="show" style='border-left: 18px solid #1e66cd;'>
									<span id="blue-key"></span>
								</td>
								<td>
									<span id="blue-desc"></span>
								</td>
							</tr>
							<tr>
								<td class="show" style='border-left: 18px solid #19bf40;'>
									<span id="green-key"></span>
								</td>
								<td>
									<span id="green-desc"></span>
								</td>
							</tr>
							<tr>
								<td class="show" style='border-left: 18px solid #d20000;'>
									<span id="red-key"></span>
								</td>
								<td>
									<span id="red-desc"></span>
								</td>
							</tr>
							<tr>
								<td class="show" style='border-left: 18px solid #646464;'>
									<span id="grey-key"></span>
								</td>
								<td>
									<span id="grey-desc"></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div -->

				<div class="clear"></div>

				<p class="ranking-results-show-info"></p>

			</div>
		</div>



	</form>
</div>
`;

export default template;
